import {MeasureMode} from './MeasureMode';

export class MeasureModeItem {
collectContent: string[];
content: MeasureModeItem[];
errorCode: string;
fake: boolean | null;
flagCollection: boolean;
flagComparator: boolean;
flagConstant: boolean;
flagFunction: boolean;
flagOperand: boolean;
flagOperator: boolean;
flagParenthesis: boolean;
flagTerminal: boolean;
flagText: boolean;
functionCode: string;
hasError: boolean;
measureMode: MeasureMode;
nbComparators: number | null;
rawFormula: string;
result: string;
}

